export default __webpack_public_path__ + "static/ubuntu-v20-latin-regular-6a317272decf6d2470386df117732fa6.woff";